import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import { ReactElement, useState } from 'react';
import moment from 'moment';
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import { getLegacyPath } from 'routes/_utils';
import Styles from './OtherApplications.component.module.scss';
import StyleAuxiliary from '../../../../hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';
/**
 * Wrapping component for App Processing Form
 *
 * @returns {ReactElement} rendered component.
 */
const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: '#771b61',
		color: theme.palette.common.white,
		whiteSpace: 'nowrap',
		width: '1%',
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 14,
	},
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	'&:nth-of-type(odd)': {
		backgroundColor: theme.palette.action.hover,
	},
	'&:hover': {
		backgroundColor: theme.palette.action.selected,
	},
	// hide last border
	'&:last-child td, &:last-child th': {
		border: 0,
	},
}));

const OtherApplications = ({ otherApps, wqReport }) => {
	const [refireOpen, setRefireOpen] = useState(false);
	const [rowLink, setRowLink] = useState(null);

	// const allowRefire = false;
	// Keep this because in future we will enable the request processing page via the reports page
	// Need to determine if this being rendered via WQ or via reports
	// const [allowRefire, setAllowRefire] = useState(false);

	// useEffect(() => {
	// 	setAllowRefire(false);

	// 	// Event types that you can re-fire emails on
	// 	// AC Completed, AC Declined, AC Cancelled, Unable to Process
	// 	const refirableEventTypes = [52, 53, 307, 866];

	// 	const hasMatchingEventType = otherApps?.some(app =>
	// 		refirableEventTypes.includes(app.EventType)
	// 	);

	// 	if (hasMatchingEventType) {
	// 		setAllowRefire(true);
	// 	} else {
	// 		setAllowRefire(false);
	// 	}
	// }, [otherApps]);

	return (
		<>
			<Modal open={refireOpen} onClose={() => setRefireOpen(false)}>
				<div className={Styles.RequestProcessingModal}>
					<IconButton className={Styles.closeModalIcon}>
						<CloseIcon
							fontSize={'large'}
							onClick={() => {
								setRefireOpen(false);
							}}
						/>
					</IconButton>
					<StyleAuxiliary classes={Styles.processingPageControls}>
						<iframe title={rowLink} src={rowLink} />
					</StyleAuxiliary>
				</div>
			</Modal>
			<Grid
				container
				spacing={3}
				alignItems='center'
				justifyContent='center'
			>
				<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
					<TableContainer>
						<Table size='medium' aria-label='Other Applications'>
							<TableHead>
								<StyledTableRow>
									<StyledTableCell>
										<strong>Queue</strong>
									</StyledTableCell>
									<StyledTableCell>
										<strong>Application</strong>
									</StyledTableCell>
									<StyledTableCell>
										<strong>Workflow Step</strong>
									</StyledTableCell>
									<StyledTableCell>
										<strong>Status</strong>
									</StyledTableCell>
									<StyledTableCell>
										<strong>Date Processed</strong>
									</StyledTableCell>
									{wqReport && (
										<StyledTableCell>
											<strong>Completion Email</strong>
										</StyledTableCell>
									)}
								</StyledTableRow>
							</TableHead>
							<TableBody>
								{otherApps?.map(app => (
									<StyledTableRow key={app?.ApplicationName}>
										<StyledTableCell
											component='th'
											scope='row'
										>
											{app?.SystemName}
										</StyledTableCell>
										<StyledTableCell>
											{app?.ApplicationName}
										</StyledTableCell>
										<StyledTableCell>
											{app?.WorkFlowStep}
										</StyledTableCell>
										<StyledTableCell>
											{app?.Status}
										</StyledTableCell>
										<StyledTableCell>
											{moment(app?.DateProcessed).format(
												'LLL'
											)}
										</StyledTableCell>
										{wqReport && (
											<StyledTableCell>
												<Chip
													sx={{
														p: 2,
													}}
													label='Refire Email'
													onClick={() => {
														setRowLink(
															getLegacyPath(
																`/WorkQueue/RefireEmail.aspx?eid=${app.EventID}&et=1`
															)
														);
														setRefireOpen(true);
													}}
													clickable
													icon={<SendIcon />}
													variant='outlined'
												/>
											</StyledTableCell>
										)}
									</StyledTableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				</Grid>
				{wqReport && (
					<Grid item justifyContent='center'>
						<Chip
							sx={{
								p: 2,
							}}
							label='Refire All Emails'
							onClick={() => {
								setRowLink(
									getLegacyPath(
										`/WorkQueue/RefireEmail.aspx?eid=${otherApps[0].EventID}&et=3`
									)
								);
								setRefireOpen(true);
							}}
							clickable
							icon={<SendIcon />}
							variant='outlined'
						/>
					</Grid>
				)}
			</Grid>
		</>
	);
};

export default OtherApplications;
